module.exports = __webpack_public_path__ + "img/icon_suporte_tecnico_servicos_home.8a0720ff.svg";